var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircuitry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9888 5.26514H9.98877C8.99421 5.26514 8.04038 5.66022 7.33712 6.36349C6.63386 7.06675 6.23877 8.02057 6.23877 9.01514V39.0151C6.23877 40.0097 6.63386 40.9635 7.33712 41.6668C8.04038 42.37 8.99421 42.7651 9.98877 42.7651H39.9888C40.9833 42.7651 41.9372 42.37 42.6404 41.6668C43.3437 40.9635 43.7388 40.0097 43.7388 39.0151V9.01514C43.7388 8.02057 43.3437 7.06675 42.6404 6.36349C41.9372 5.66022 40.9833 5.26514 39.9888 5.26514ZM10.7388 9.76514H15.2388V28.5151C14.6091 28.9874 14.144 29.6458 13.9093 30.397C13.6747 31.1483 13.6823 31.9543 13.9312 32.701C14.1801 33.4477 14.6576 34.0971 15.2961 34.5573C15.9346 35.0175 16.7017 35.2651 17.4888 35.2651C18.2758 35.2651 19.0429 35.0175 19.6814 34.5573C20.3199 34.0971 20.7974 33.4477 21.0463 32.701C21.2952 31.9543 21.3029 31.1483 21.0682 30.397C20.8335 29.6458 20.3684 28.9874 19.7388 28.5151V23.4526L27.2388 30.9526V38.2651H10.7388V9.76514ZM39.2388 38.2651H31.7388V30.0151C31.739 29.7196 31.681 29.4269 31.5681 29.1537C31.4552 28.8806 31.2895 28.6324 31.0806 28.4233L19.7388 17.0776V9.76514H24.2388V13.5151C24.2385 13.8107 24.2965 14.1034 24.4095 14.3765C24.5224 14.6497 24.688 14.8979 24.8969 15.107L28.78 18.9883C28.6636 19.7751 28.7982 20.5785 29.1647 21.2845C29.5311 21.9904 30.1109 22.5628 30.8214 22.9202C31.5319 23.2777 32.337 23.4021 33.1223 23.2757C33.9075 23.1493 34.6329 22.7785 35.1953 22.2161C35.7578 21.6537 36.1285 20.9283 36.255 20.143C36.3814 19.3577 36.257 18.5526 35.8995 17.8421C35.542 17.1316 34.9696 16.5519 34.2637 16.1854C33.5578 15.8189 32.7543 15.6843 31.9675 15.8008L28.7388 12.5776V9.76514H39.2388V38.2651Z",
    fill: "url(#paint0_linear_1660_9473)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1660_9473",
    x1: 24.9888,
    y1: 5.26514,
    x2: 24.9888,
    y2: 42.7651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircuitry);
export default __webpack_public_path__ + "static/media/Circuitry.17c582955cfb1fbad6fa3ae6a68ab713.svg";
export { ForwardRef as ReactComponent };